import { render, staticRenderFns } from "./NewForm.vue?vue&type=template&id=20dfcb28&"
import script from "./NewForm.vue?vue&type=script&lang=ts&"
export * from "./NewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports